export default __webpack_public_path__ + "static/media/productos.d59a857c.jpg";